import { RSAA } from 'redux-api-middleware';

const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE';

export const createRefreshToken = (refreshToken: string, userId: string) => ({
  [RSAA]: {
    isPublic: true,
    types: [REFRESH_TOKEN_REQUEST, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_FAILURE],
    endpoint: `/sessions/${userId}/refresh`,
    method: 'POST',
    body: {
      refreshToken,
    },
  },
});
